import { useEffect } from "react";
import { authHeader } from "../auth";

// Signale "quelqu'un travaille sur cette catégorie, sur cette page" au
// serveur toutes les ~8s tant que le composant reste monté. Purement
// informatif (page /parallel), pas de données sensibles envoyées.
export function usePresencePing(category, page) {
    useEffect(() => {
        if (!category) return;

        const ping = () => {
            fetch(`/api/presence/${encodeURIComponent(category)}`, {
                method: "POST",
                headers: { "Content-Type": "application/json", ...authHeader() },
                body: JSON.stringify({ page }),
            }).catch(() => {
                /* silencieux : un battement manqué n'est pas grave */
            });
        };

        ping();
        const interval = setInterval(ping, 8000);
        return () => clearInterval(interval);
    }, [category, page]);
}